import * as React from 'react';
import {WrappedFieldProps} from 'redux-form';

type Props = {
    label: string;
    options: any;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    placeholder: string;
    wrapperClassName?: string;
    e2eId?: string
};

class RenderAreaField extends React.PureComponent<WrappedFieldProps & Props> {
    public render() {
        const {input, meta, label, type, max, min, disabled, placeholder, wrapperClassName} = this.props;
        let formClasses: string = 'form-field';
        formClasses += meta.error && meta.touched ? ' form-field--error' : '';
        formClasses += wrapperClassName ? ` ${wrapperClassName} ` : '';
        formClasses += disabled ? ' form_field--disabled' : '';

        return (
            <div className={formClasses}>
                <label className="form-field__label" htmlFor={input.name}>{label}</label>
                <div>
                    <textarea
                        className="form-field__input"
                        disabled={disabled || false}
                        {...input}
                        placeholder={placeholder ? placeholder : label}
                    />
                    {(meta.touched &&
                        (meta.error && (
                            <div className="form-field__error"
                                 date-e2eid={(this.props.e2eId) ? this.props.e2eId + "_error" : null}>
                                {meta.error}
                            </div>
                        ))) ||
                    (meta.warning && <span>{meta.warning}</span>)}
                </div>
            </div>
        );
    }
}

export default RenderAreaField;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/RenderAreaField.tsx